import React, {useState, useEffect, useCallback} from 'react';
import {debounce} from 'lodash';
import {PlusIcon} from '@heroicons/react/outline';

import Button, {ButtonSizes, ButtonTypes} from './ButtonNew';
import {isFollowing, followTag, unfollowTag} from '../api/api';
import {useAppContext} from '../hooks';

/**
 * Only appears for logged in users
 */
const FollowButton = ({
  tag, onClick, succinct = true, hasIcon = false, ...props
}) => {
  const [following, setFollowing] = useState(false);
  const {currentUser} = useAppContext();

  useEffect(() => {
    if (currentUser && tag) {
      isFollowing(tag.id).then(setFollowing);
    } else if (!tag) {
      setFollowing(false);
    }
  }, [currentUser, tag?.id]);

  const toggleFollowing = useCallback(debounce(async (currFollowing) => {
    if (onClick) onClick(!currFollowing);
    setFollowing(!currFollowing);
    return currFollowing ? unfollowTag(tag.id) : followTag(tag.id);
  }, 300, {leading: true, trailing: false}), [tag?.id, currentUser]);

  return currentUser && tag ? (
    <Button
      onClick={() => toggleFollowing(following)}
      buttonType={ButtonTypes.SECONDARY}
      {...props}
    >
      {hasIcon && !following && <PlusIcon className="h-4 w-4 mr-1" />}
      {`${following ? 'Following' : 'Follow'}${succinct ? '' : ` ${tag.name}`}`}
    </Button>
  ) : null;
};

export {ButtonSizes, ButtonTypes};
export default FollowButton;
